export const sortKitchenOrders = (order1, order2) => {
	return order1.floatingIndex - order2.floatingIndex
}
